export default {
  less: "less",
  more: "more",
  seeButton: "See [mol] [module]"
};
